export const actions = {
    SET_PAGE_TITLE: "SET_PAGE_TITLE" as const,
    SET_PAGE_DESCRIPTION: "SET_PAGE_DESCRIPTION" as const,
};

export interface SetTitleAction {
    type: typeof actions.SET_PAGE_TITLE,
    title: string;
};

export type TitleAction = SetTitleAction;

export const setTitle = (title: string): SetTitleAction => {
    return {
        type: actions.SET_PAGE_TITLE,
        title,
    };
};

export interface SetDescriptionAction {
    type: typeof actions.SET_PAGE_DESCRIPTION,
    description: string;
};

export type DescriptionAction = SetDescriptionAction;

export const setDescription = (description: string): SetDescriptionAction => {
    return {
        type: actions.SET_PAGE_DESCRIPTION,
        description,
    };
};